import { IGetEventsOutput } from '../interfaces/iGetEventsOutput';

export class GetEventsOutput {
	orgKey?: string;
	eventType?: string;
	eventKey?: string;
	isAts?: boolean;

	constructor(getEventsOutput: IGetEventsOutput = {} as IGetEventsOutput) {
		this.orgKey = getEventsOutput.orgKey;
		this.eventType = getEventsOutput.eventType;
		this.eventKey = getEventsOutput.eventKey;
		this.isAts = !!getEventsOutput.isAts || false;
	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/getEventsOutput.ts